var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "custom-multiselect",
      class: { "is-open": _vm.isOpen },
      attrs: { name: _vm.name },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-multiselect-selection",
          attrs: { id: _vm.name },
          on: { click: _vm.toggleDropdown },
        },
        [
          _vm.multiple
            ? [
                _vm.selected.length
                  ? _c(
                      "div",
                      { staticClass: "custom-multiselect-tags" },
                      [
                        _vm._l(_vm.visibleTags, function (item) {
                          return _c(
                            "span",
                            {
                              key: _vm.getOptionKey(item),
                              staticClass: "custom-multiselect-tag",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.getOptionLabel(item)) +
                                  "\n                    "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-close",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Remove",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeItem(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [_vm._v("×")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.remainingTagsCount > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "custom-multiselect-tag remaining",
                              },
                              [
                                _vm._v(
                                  "\n                    +" +
                                    _vm._s(_vm.remainingTagsCount) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _c(
                      "span",
                      { staticClass: "custom-multiselect-placeholder" },
                      [_vm._v(_vm._s(_vm.placeholder))]
                    ),
              ]
            : [
                _c(
                  "span",
                  {
                    class: {
                      "custom-multiselect-placeholder": !_vm.selected.length,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.selected.length
                            ? _vm.getOptionLabel(_vm.selected[0])
                            : _vm.placeholder
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-multiselect-actions" },
            [
              _vm.selected.length && _vm.showResetButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn-clear",
                      attrs: {
                        type: "button",
                        "aria-label": "Clear selection",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clearSelection.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { "aria-hidden": "true" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.icons.faRotateLeft, size: "sm" },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("font-awesome-icon", {
                staticClass: "custom-multiselect-caret",
                attrs: { icon: _vm.icons.faChevronDown },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "custom-multiselect-dropdown",
        },
        [
          _vm.showSearch
            ? _c("div", { staticClass: "custom-multiselect-search" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchQuery,
                      expression: "searchQuery",
                    },
                  ],
                  ref: "searchInput",
                  attrs: { type: "text", placeholder: _vm.searchPlaceholder },
                  domProps: { value: _vm.searchQuery },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchQuery = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.multiple
                  ? _c(
                      "button",
                      {
                        staticClass: "custom-multiselect-toggle-all",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleAll.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.areAllFiltered
                                ? _vm.$t("actions.unselect_all")
                                : _vm.$t("actions.select_all")
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-multiselect-options" },
            [
              _vm.isGrouped
                ? _vm._l(_vm.filteredOptions, function (group) {
                    return _c(
                      "div",
                      {
                        key: group[_vm.groupBy],
                        staticClass: "custom-multiselect-group",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "custom-multiselect-group-label",
                            on: {
                              click: function ($event) {
                                return _vm.toggleGroup(group[_vm.groupBy])
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(group[_vm.groupBy]) +
                                  ": " +
                                  _vm._s(group.options.length)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.isGroupCollapsed(group[_vm.groupBy])
                                  ? _vm.icons.faChevronDown
                                  : _vm.icons.faChevronUp,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isGroupCollapsed(
                                  group[_vm.groupBy]
                                ),
                                expression: "!isGroupCollapsed(group[groupBy])",
                              },
                            ],
                          },
                          _vm._l(group.options, function (option) {
                            return _c(
                              "div",
                              {
                                key: _vm.getOptionKey(option),
                                staticClass: "custom-multiselect-option",
                                class: {
                                  "is-selected": _vm.isSelected(option),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleOption(option)
                                  },
                                },
                              },
                              [
                                _vm.multiple
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticStyle: {
                                          "pointer-events": "none",
                                        },
                                        attrs: {
                                          checked: _vm.isSelected(option),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.getOptionLabel(option)) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.getOptionLabel(option)) +
                                          "\n                            "
                                      ),
                                    ]),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  })
                : _vm._l(_vm.filteredOptions, function (option) {
                    return _c(
                      "div",
                      {
                        key: _vm.getOptionKey(option),
                        staticClass: "custom-multiselect-option",
                        class: { "is-selected": _vm.isSelected(option) },
                        on: {
                          click: function ($event) {
                            return _vm.toggleOption(option)
                          },
                        },
                      },
                      [
                        _vm.multiple
                          ? _c(
                              "b-form-checkbox",
                              {
                                staticStyle: { "pointer-events": "none" },
                                attrs: { checked: _vm.isSelected(option) },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.getOptionLabel(option)) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getOptionLabel(option)) +
                                  "\n                    "
                              ),
                            ]),
                      ],
                      1
                    )
                  }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }